import { Fleet } from "../models/cars.model";
import * as _ from "lodash";

function getSelfDriveBikes(): Array<Fleet> {
    const bikes = [
        //Kudal HUB Cars
        {
            "Brand": "Honda",
            "Name": "Activa",
            "Charges": [600],
            "HalfDayCharges": [600],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Kankavli"
            ],
            "Hub": "Kudal, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "activa.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "TVS",
            "Name": "Jupiter",
            "Charges": [600],
            "HalfDayCharges": [600],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Kankavli"
            ],
            "Hub": "Kudal, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "jupiter.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "Suzuki",
            "Name": "Access",
            "Charges": [600],
            "HalfDayCharges": [600],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Kankavli"
            ],
            "Hub": "Kudal, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "access.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "Hero",
            "Name": "Splendor",
            "Charges": [800],
            "HalfDayCharges": [800],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Kankavli"
            ],
            "Hub": "Kudal, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [9],
            "Image": "splendor.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Manual",
                "Avg/Ltr": "55"
            }
        },

        //Sawantwadi HUB Cars
        {
            "Brand": "Honda",
            "Name": "Activa",
            "Charges": [600],
            "HalfDayCharges": [600],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Sawantwadi",
                "Malvan",
                "Tarkarli",
                "Kankavli"
            ],
            "Hub": "Sawantwadi, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "activa.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "TVS",
            "Name": "Jupiter",
            "Charges": [600],
            "HalfDayCharges": [600],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Sawantwadi",
                "Malvan",
                "Tarkarli",
                "Kankavli"
            ],
            "Hub": "Sawantwadi, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "jupiter.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "Suzuki",
            "Name": "Access",
            "Charges": [600],
            "HalfDayCharges": [600],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Sawantwadi",
                "Malvan",
                "Tarkarli",
                "Kankavli"
            ],
            "Hub": "Sawantwadi, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "access.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },

        //Ratnagiri HUB Cars
        {
            "Brand": "Honda",
            "Name": "Activa",
            "Charges": [700],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "activa.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "TVS",
            "Name": "Jupiter",
            "Charges": [700],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "jupiter.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "Suzuki",
            "Name": "Access",
            "Charges": [700],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "access.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "Hero",
            "Name": "Maestro",
            "Charges": [700],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [8],
            "Image": "maestro.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Automatic",
                "Avg/Ltr": "45"
            }
        },
        {
            "Brand": "Royal Enfield",
            "Name": "Classic 350",
            "Charges": [1400],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 2000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [10],
            "Image": "classic350.webp",
            "Details": {
                "Fuel": "Petrol",
                "SeatingCapacity": 2,
                "LuggageCapacity": 0,
                "Transmission": "Manual",
                "Avg/Ltr": "30"
            }
        },
    ]
    return _.sortBy(bikes, ['Charges']);
}
export default getSelfDriveBikes;